import axios, { AxiosResponse } from 'axios'
import {
  NotificacaoAdminView,
  NotificacaoDtoEnvio,
  NotificacaoDtoLote,
  NotificacaoView,
  PageResponseNotificacaoAdminList,
  PageResponseNotificacaoList,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const NOTIFICACAO_URL = `${API_URL}/notificacoes`

/**
 * Busca as notificações do usuário logado
 * @param query string
 * @returns PageResponseNotificacaoList
 */
export const getNotificacoes = (query: string): Promise<PageResponseNotificacaoList> => {
  return axios
    .get(`${NOTIFICACAO_URL}?${query}`)
    .then((d: AxiosResponse<PageResponseNotificacaoList>) => d.data)
}

/**
 * Busca uma notificação do usuário logado e marca como lida
 * @param notificacaoId ID da notificação
 * @returns NotificacaoView
 */
export const getNotificacaoById = (notificacaoId: number): Promise<NotificacaoView> => {
  return axios
    .get(`${NOTIFICACAO_URL}/${notificacaoId}`)
    .then((d: AxiosResponse<NotificacaoView>) => d.data)
}

/**
 * Remove notificações em lote.
 * @param data NotificacaoDtoLote
 * @returns
 */
export const deleteNotificacoes = (data: NotificacaoDtoLote): Promise<void> => {
  return axios.delete(`${NOTIFICACAO_URL}`, { data })
}

/**
 * Marca uma notificação como lida
 * @param notificacaoId ID da notificação
 * @returns NotificacaoView
 */
export const marcarNotificacaoComoLida = (notificacaoId: number): Promise<NotificacaoView> => {
  return axios
    .put(`${NOTIFICACAO_URL}/${notificacaoId}/lida`)
    .then((response: AxiosResponse<NotificacaoView>) => response.data)
}

/**
 * Marca notificações em lote como lidas
 * @param data NotificacaoDtoLote
 * @returns SuccesResponse
 */
export const marcarTodasNotificacoesComoLidas = (data: NotificacaoDtoLote): Promise<void> => {
  return axios.put(`${NOTIFICACAO_URL}/lidas`, data)
}

/**
 * Conta as notificações não lidas do usuário logado
 * @returns Total
 */
export const getNotificacoesNaoLidasCount = (): Promise<{ total: number }> => {
  return axios
    .get(`${NOTIFICACAO_URL}/nao-lidas/total`)
    .then((response: AxiosResponse<{ total: number }>) => response.data)
}

/**
 * Cria e envia uma notificação segmentada para usuários da plataforma
 * @param data NotificacaoDtoEnvio
 * @returns NotificacaoDtoEnvio
 */
export const sendNotificacao = (data: NotificacaoDtoEnvio): Promise<NotificacaoDtoEnvio> => {
  return axios
    .post(`${NOTIFICACAO_URL}/enviar`, data)
    .then((response: AxiosResponse<NotificacaoDtoEnvio>) => response.data)
}

/**
 * Lista todas as notificações da plataforma, com destinatário (visão administrativa)
 * @param query string
 * @returns PageResponseNotificacaoAdminList
 */
export const getNotificacoesAdmin = (query: string): Promise<PageResponseNotificacaoAdminList> => {
  return axios
    .get(`${NOTIFICACAO_URL}/listar?${query}`)
    .then((d: AxiosResponse<PageResponseNotificacaoAdminList>) => d.data)
}

/**
 * Detalhe administrativo de uma notificação. Não marca como lida (diferente de getNotificacaoById)
 * @param notificacaoId ID da notificação
 * @returns NotificacaoAdminView
 */
export const getNotificacaoAdminById = (notificacaoId: number): Promise<NotificacaoAdminView> => {
  return axios
    .get(`${NOTIFICACAO_URL}/visualizar/${notificacaoId}`)
    .then((d: AxiosResponse<NotificacaoAdminView>) => d.data)
}
